var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import $ from "jquery";
// import BottomDataHoc from './BottomDataHoc.tsx';
import LayerDevices from '../layerInfo/layers-devices/Layer-devices';
import LayerInfo1 from '../layerInfo/layers-distribution/LayerInfo1';
import LayerPois from '../layerInfo/layers-pois/Layer-pois';
import LayerRegions from '../layerInfo/layers-regions/Layer-regions';
import { withTranslation } from 'react-i18next';
import { update } from 'lodash-es';
// import LayerInfo1 from '../layerInfo/LayerInfo1';

var BottomData = function (_React$Component) {
	_inherits(BottomData, _React$Component);

	function BottomData(props) {
		_classCallCheck(this, BottomData);

		var _this = _possibleConstructorReturn(this, (BottomData.__proto__ || Object.getPrototypeOf(BottomData)).call(this, props));

		_this.onClickMore = function () {
			$("#layer-container").toggleClass("container-options-open");
			$("#line-layers-container").toggleClass("line-layers-container-open");
			if ($("#icon-more").hasClass("fas fa-ellipsis-h")) {
				$("#icon-more").removeClass("fas fa-ellipsis-h");
				$("#icon-more").addClass("fas fa-chevron-up");
				$("#text-icon-more").text("Menos");
			} else {
				$("#icon-more").removeClass("fas fa-chevron-up");
				$("#icon-more").addClass("fas fa-ellipsis-h");
				$("#text-icon-more").text("Más");
			}
		};

		_this.setGroupDeviceOpen = function (deviceId) {

			_this.setState({
				groupOpenDevice: deviceId
			});
		};

		_this.setDeviceContentOpen = function (deviceId) {
			_this.setState({
				contentOpenDevice: deviceId
			});
		};

		_this.onClick = function () {
			$("#divResize").toggleClass("widget-container-close");
			if (!$("#divResize").hasClass("widget-container-close")) {
				// $("#btn-collapse").css({display: "none"});
				$("#btn-collapse").fadeToggle("fast");
			} else {
				// $("#btn-collapse").css({display: "block"});
				$("#btn-collapse").fadeToggle("fast");
			}
			// if ($("#caret").css("transform: rotate(90deg)")) {
			// 	alert("hola");
			// 	$("#caret").removeClass("fas fa-caret-right");
			// 	$("#caret").addClass("fas fa-caret-left");
			// } else {
			// 	$("#caret").removeClass("fas fa-caret-left");
			// 	$("#caret").addClass("fas fa-caret-right");
			// }
		};

		_this.handleButtonClick = function (layerName) {
			_this.setState(function (prevState) {
				// Incrementar el order basándote en el valor máximo actual
				var maxOrder = Math.max.apply(Math, _toConsumableArray(Object.values(prevState.layers).map(function (layer) {
					return layer.order;
				})));

				var updatedLayers = Object.assign({}, prevState.layers, _defineProperty({}, layerName, Object.assign({}, prevState.layers[layerName], {
					activo: !prevState.layers[layerName].activo,
					visible: !prevState.layers[layerName].visible,
					order: _this.state.layers[layerName].order === maxOrder ? 0 : maxOrder + 1
				})));
				// incrementar el order en el caso de que vuelvas a la capa anterior.
				if (prevState.layers[layerName].activo && !prevState.layers[layerName].visible) {
					updatedLayers = Object.assign({}, prevState.layers, _defineProperty({}, layerName, Object.assign({}, prevState.layers[layerName], {
						activo: prevState.layers[layerName].activo,
						visible: !prevState.layers[layerName].visible,
						order: _this.state.layers[layerName].order === maxOrder ? 0 : maxOrder + 1
					})));
				}

				var maxOrderInfo = { order: 0, key: "" };
				Object.keys(updatedLayers).forEach(function (key) {
					if (key !== layerName && updatedLayers[key].order > maxOrderInfo.order) {
						maxOrderInfo = {
							order: updatedLayers[key].order,
							key: key
						};
					}
				});

				var changes = {};
				Object.keys(updatedLayers).forEach(function (key) {
					if (key !== layerName && updatedLayers[key].order >= maxOrder && updatedLayers[key].activo) {
						changes[key] = {
							activo: updatedLayers[key].activo,
							visible: !updatedLayers[key].visible,
							order: updatedLayers[key].order // Mantener el order original
						};
					} else if (key === layerName) {
						if (maxOrderInfo.key != "") {
							changes[maxOrderInfo.key] = {
								activo: updatedLayers[maxOrderInfo.key].activo,
								visible: !updatedLayers[maxOrderInfo.key].visible,
								order: updatedLayers[maxOrderInfo.key].order
							};
						}
					}
				});

				if (_this.state.layers[layerName].order === 0 && maxOrder === 0) {
					updatedLayers = Object.assign({}, prevState.layers, _defineProperty({}, layerName, Object.assign({}, prevState.layers[layerName], {
						activo: !prevState.layers[layerName].activo,
						visible: !prevState.layers[layerName].visible,
						order: 1
					})));
				}
				// Aplicar cambios al estado
				return {
					layers: Object.assign({}, updatedLayers, changes)
				};
			}, function () {
				_this.handleAdditionalLogic(layerName, _this.state.layers);
			});
		};

		_this.handleAdditionalLogic = function (layerName, layers) {
			if (layers[layerName].activo && layers[layerName].visible) {
				switch (layerName) {
					case 'layer1':
						if (!_this.props.layerDevice) {
							_this.props.layerDeviceFunc();
						}

						break;
					case 'layer2':
						if (!_this.props.layerDistribution) {
							_this.props.getTaskOrdersLayerFunc();
						}

						break;
					case 'layer3':
						if (!_this.props.layerPois) {
							_this.props.layerPoisFunc();
						}

						break;
					case 'layer4':
						if (!_this.props.layerRegions) {
							_this.props.layerRegionsFunc();
						}

						break;
					default:
						break;
				}
			} else if (!layers[layerName].activo && !layers[layerName].visible) {
				switch (layerName) {
					case 'layer1':
						if (_this.props.layerDevice) {
							_this.props.layerDeviceFunc();
						}

						break;
					case 'layer2':
						if (_this.props.layerDistribution) {
							_this.props.getTaskOrdersLayerFunc();
						}

						break;
					case 'layer3':
						if (_this.props.layerPois) {
							_this.props.layerPoisFunc();
						}

						break;
					case 'layer4':
						if (_this.props.layerRegions) {
							_this.props.layerRegionsFunc();
						}
						break;
					default:
						break;
				}
			}
		};

		_this.state = {
			// activeLayer: 0,
			// oldActiveLayer: '',
			option: 1,
			lastOption: 1,
			layers: {
				layer1: { activo: true, visible: true, order: 1 },
				layer2: { activo: false, visible: false, order: 0 },
				layer3: { activo: false, visible: false, order: 0 },
				layer4: { activo: false, visible: false, order: 0 }
			},
			layer1: true,
			layer2: false,
			layer3: false,
			layer4: false,
			tmp: 1,
			moving: false,
			defaultMode: "collapsed",
			layerDevice: true,
			mode: _this.props.defaultMode,
			y: '',
			heightMobile: 490,
			size: {
				width: "150px",
				height: "460px"
			},
			groupOpenDevice: '',
			contentOpenDevice: ''
		};
		return _this;
	}

	// componentDidMount() {
	// 	// this.setState({
	// 	// 	option: 1,
	// 	// });

	// }

	// Función para manejar la lógica adicional


	_createClass(BottomData, [{
		key: 'renderA',
		value: function renderA(buttonlayer0, buttonLayer1, buttonLayerPois, buttonLayerRegions) {
			var t = this.props.t;


			return React.createElement(
				'div',
				{ id: 'divResize', className: 'widget-container-open', onClick: function onClick() {}, style: { touchAction: "manipulation" } },
				React.createElement(
					'button',
					{ style: { display: "none" }, id: 'btn-collapse', onClick: this.onClick, className: 'widget-toggle-button' },
					React.createElement('i', { id: 'caret', className: 'icon-colapse_down caret-style', style: { transform: "rotate(-90deg)" } })
				),
				React.createElement(
					'div',
					{ className: 'first-container' },
					React.createElement(
						'div',
						{ className: 'container-options-layers' /*style={{ overflowX: "scroll" }}*/ },
						React.createElement(
							'label',
							{ className: 'label-color' },
							buttonlayer0,
							React.createElement(
								'p',
								{ style: { fontSize: "14px", marginTop: "10px" } },
								t("map.sidebar.buttons.devicesBtn")
							)
						),
						this.props.permisionDistribution ? React.createElement(
							'label',
							{ className: 'label-color' },
							buttonLayer1,
							React.createElement(
								'p',
								{ style: { fontSize: "14px", marginTop: "10px" } },
								t("map.sidebar.buttons.distributionBtn")
							)
						) : null,
						this.props.permisionPois ? React.createElement(
							'label',
							{ className: 'label-color' },
							buttonLayerPois,
							React.createElement(
								'p',
								{ style: { fontSize: "14px", marginTop: "10px" } },
								t("map.sidebar.buttons.poisBtn")
							)
						) : null,
						this.props.permisionRegiones ? React.createElement(
							'label',
							{ className: 'label-color' },
							buttonLayerRegions,
							React.createElement(
								'p',
								{ style: { fontSize: "14px", marginTop: "10px" } },
								t("map.sidebar.buttons.regionsBtn")
							)
						) : null
					),
					React.createElement('div', { className: 'line2' }),
					React.createElement('div', { id: 'line-layers-container', className: 'line-layers-container' }),
					React.createElement(
						'div',
						{ className: 'second-container' },
						React.createElement(
							'div',
							{ className: 'layer-container' },
							React.createElement(
								'aside',
								{ className: 'main-sidebar-map' },
								this.state.layers.layer1.visible ? React.createElement(LayerDevices, { accessToken: this.props.accessToken, permisionActivator: this.props.permisionActivator, transformDateAndCompare: this.props.transformDateAndCompare, contentOpenDevice: this.state.contentOpenDevice, setDeviceContentOpen: this.setDeviceContentOpen, groupOpenDevice: this.state.groupOpenDevice, setGroupDeviceOpen: this.setGroupDeviceOpen, centerMapWihtOutFollow: this.props.centerMapWihtOutFollow, isOpenDeviceContent: this.props.isOpenDeviceContent, centerDevice: this.props.centerDevice, setLatLng: this.props.setLatLng, click: this.onClick, groupsDevicesList: this.props.groupsDevicesList, child: this.props.children, realTimeDevices: this.props.realTimeDevices, centerMap: this.props.centerMap, valueFilter: this.props.valueFilter,
									filterForGroups: this.props.filterForGroups, filterForDevice: this.props.filterForDevice }) : null
							),
							React.createElement(
								'aside',
								{ className: 'main-sidebar-map' },
								this.state.layers.layer2.activo && this.state.layers.layer2.visible ? React.createElement(LayerInfo1, { groupOpen: this.state.groupOpen, setGroupDeviceOpen: this.setGroupDeviceOpen, centerMap: this.props.centerMap, click: this.onClick, groupsTasksServicesList: this.props.groupsTasksServicesList, child: this.props.children }) : null
							),
							React.createElement(
								'aside',
								{ className: 'main-sidebar-map' },
								this.state.layers.layer3.activo && this.state.layers.layer3.visible ? React.createElement(LayerPois, { groupOpen: this.state.groupOpen, setGroupDeviceOpen: this.setGroupDeviceOpen, centerMap: this.props.centerMap, groupsPois: this.props.groupsPois, centerMapWihtOutFollow: this.props.centerMapWihtOutFollow, click: this.onClick, child: this.props.children, handleCheckboxPoisChange: this.props.handleCheckboxPoisChange, handleCheckboxPoiChange: this.props.handleCheckboxPoiChange }) : null
							),
							React.createElement(
								'aside',
								{ className: 'main-sidebar-map' },
								this.state.layers.layer4.activo && this.state.layers.layer4.visible ? React.createElement(LayerRegions, { groupRegions: this.props.groupRegions, layerRegionsFunc: this.props.layerRegionsFunc, groupOpen: this.state.groupOpen, setGroupDeviceOpen: this.setGroupDeviceOpen, centerMap: this.props.centerMap, centerMapWihtOutFollow: this.props.centerMapWihtOutFollow, click: this.onClick, child: this.props.children, handleCheckboxPoisChange: this.props.handleCheckboxPoisChange, handleCheckboxPoiChange: this.props.handleCheckboxPoiChange, handleCheckboxRegionsChange: this.props.handleCheckboxRegionsChange, handleCheckboxRegionChange: this.props.handleCheckboxRegionChange }) : null
							)
						)
					)
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			// // console.log("render BottomData.js");

			var layers = this.state.layers;


			var buttonLayer0 = void 0;
			var buttonLayer1 = void 0;
			var buttonLayerPois = void 0;
			var buttonLayerRegions = void 0;
			buttonLayer0 = React.createElement(
				'button',
				{ id: 'layer1-btn', style: { background: layers.layer1.activo && layers.layer1.visible ? "#bf2349" : "" }, onClick: function onClick() {
						return _this2.handleButtonClick('layer1');
					}, className: 'btn-layers' },
				React.createElement('span', { id: 'label-vehicles',
					style: { fontSize: "25px", lineHeight: "1.7", color: layers.layer1.activo && layers.layer1.visible ? "#fff" : layers.layer1.activo && !layers.layer1.visible ? "#000" : "" }, className: 'icon-vehicles' })
			);

			buttonLayer1 = React.createElement(
				'button',
				{ id: 'layer2-btn', style: { background: layers.layer2.activo && layers.layer2.visible ? "#bf2349" : "" }, onClick: function onClick() {
						return _this2.handleButtonClick('layer2');
					}, className: 'btn-layers' },
				React.createElement('span', { id: 'label-vehicles', style: { fontSize: "25px", lineHeight: "1.7", color: layers.layer2.activo && layers.layer2.visible ? "#fff" : layers.layer2.activo && !layers.layer2.visible ? "#000" : "" }, className: 'newIcon-capa_d4service-content' })
			);

			buttonLayerPois = React.createElement(
				'button',
				{ id: 'layer3-btn', style: { background: layers.layer3.activo && layers.layer3.visible ? "#bf2349" : "" }, onClick: function onClick() {
						return _this2.handleButtonClick('layer3');
					}, className: 'btn-layers' },
				React.createElement('span', { style: { fontSize: "25px", lineHeight: "1.7", color: layers.layer3.activo && layers.layer3.visible ? "#fff" : layers.layer3.activo && !layers.layer3.visible ? "#000" : "" }, className: 'icon-poiRfid' })
			);

			buttonLayerRegions = React.createElement(
				'button',
				{ id: 'layer4-btn', style: { background: layers.layer4.activo && layers.layer4.visible ? "#bf2349" : "" }, onClick: function onClick() {
						return _this2.handleButtonClick('layer4');
					}, className: 'btn-layers' },
				React.createElement('span', { style: { fontSize: "25px", lineHeight: "1.7", color: layers.layer4.activo && layers.layer4.visible ? "#fff" : layers.layer4.activo && !layers.layer4.visible ? "#000" : "" }, className: 'icon-square' })
			);

			return this.renderA(buttonLayer0, buttonLayer1, buttonLayerPois, buttonLayerRegions);
		}
	}]);

	return BottomData;
}(React.Component);

export default withTranslation()(BottomData);